import React, { Component } from 'react';

class AboutObject extends Component {
    state = {
        objectives: [
            'To be one of the leading Facility Management Companies in the market and to maintain a good market share stand',
            'To achieve highest satisfaction levels for both stakeholders and clients',
            'To be the best Customer Relation oriented organization ',
            'To ensure that our client’s properties and work environment are safe and healthy to perform daily life tasks',
            'To be always proactive in implementing our planned maintenance to reduce equipment defects and increase its life span',
            'To ensure lowest energy consumption possible in all properties we manage',
            'To establish long term relation with our clients based on trust and good understanding for their needs'
        ]
    }
    render() {
      return (
        <React.Fragment>
            <p id="title">EMS Objectives</p>
            <ul>
                {
                    this.state.objectives.map(o => {
                        return <li>{o}</li>
                    })
                }
            </ul>
        </React.Fragment>
      );
   }
}

export default AboutObject;